import { render, staticRenderFns } from "./contratosTabela.vue?vue&type=template&id=1faf2937&scoped=true"
import script from "./contratosTabela.vue?vue&type=script&lang=js"
export * from "./contratosTabela.vue?vue&type=script&lang=js"
import style0 from "./contratosTabela.vue?vue&type=style&index=0&id=1faf2937&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faf2937",
  null
  
)

export default component.exports